import React from "react";
import { MatchUserType } from ".";
import styled from "styled-components";

interface Props {
    userType: MatchUserType;
}
const MatchCompleteNotification = ({ userType }: Props) => {
    if (userType === "user") {
        return <NotificationBox>전문가가 완료를 기다리고 있어요</NotificationBox>;
    }
    return <NotificationBox>의뢰인에게 완료 요청을 보냈어요</NotificationBox>;
};

export default MatchCompleteNotification;

const NotificationBox = styled.div`
    width: 100%;
    height: 100%;
    background-color: #ffdad8;
    border-radius: 8px;
    padding: 12px;
    color: #f6494b;
    font-size: 14px;
    display: flex;
    align-items: center;
    justify-content: center;
`;
